import React,{useState} from 'react';
import { Grid,InputLabel,FormControl, Typography,TextField,Button,Backdrop,CircularProgress } from '@material-ui/core';
import useStyles from "../../../themes/style.js";import axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotification } from "../../../hooks/useNotification.js";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";



const GeneralLoanForm = () => {
    const classes= useStyles();
    const token = localStorage.getItem("token");
    const location_ = useLocation();
    const handleNotificationCall = useNotification();
    const searchParam = new URLSearchParams(location_.search);
    const [loader, setLoader] = useState(false);

    const userId = searchParam.get("userId");

     const validationSchema = Yup.object().shape({
       
          principalAmount: Yup.number().typeError("Principal Amount is required")
          .required("Principal Amount is required")
          ,
          interestRate: Yup.number().typeError("Interest Rate is required")
          .required("Interest Rate is required")
          ,
          amountOfTime: Yup.number().typeError("Amount Time is required")
          .required("Amount Time is required")
          ,
          reason: Yup.string(),
          document: Yup.mixed().notRequired().test("fileType", "Only PDF or Word documents are allowed", (value) => {
            if (!value || value.length==0) return true;
            let fileValue = value;
            if (value instanceof FileList) {
              fileValue = value[0];
            }
            return (
              fileValue &&
              [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              ].includes(fileValue.type)
            );
          })
          .test("fileSize", "File size should not exceed 2MB", (value) => {
            if (!value || value.length==0) return true;
            let fileValue = value;
            if (value instanceof FileList) {
              fileValue = value[0];
            }
            return fileValue && fileValue.size <= 2 * 1024 * 1024;
          })
       
      });
    
      const {
        register,
        control,
        handleSubmit,
        setValue,
        reset,
        formState: { errors },
      } = useForm({
        resolver: yupResolver(validationSchema),
      });

      console.log(userId);

      async function handleLoanFormSubmit(value){
        console.log(value,"Data");

        const formData = new FormData();
        formData.append("userId",userId);
        formData.append("document",value.document[0]);
        

        const {document,...newData}=value;

        Object.entries(newData).forEach(([key, value]) => {
            formData.append(key, value);
                   
                 });
                 
                 
          console.log(...formData,"Form Data");


        try {
            const viewAlldata = await axios.post(
              `${process.env.REACT_APP_SERVER}loan/addLoan`,
              formData
              ,
              {
                headers: {
                  Authorization: token,
                  "Content-Type": "multipart/form-data"
                },
              },
            );
            if (viewAlldata.data.status) {
            
              setLoader(false);
              handleNotificationCall("success", viewAlldata.data.message);
              reset();
            } else {
              handleNotificationCall("error", viewAlldata.data.message);
            }
          } catch (error) {
            console.log(error);
            handleNotificationCall("error", "Error Happend!");
          } finally {
            setLoader(false);
          }

        console.log(...formData.entries());

        }

      

  return (
    <div className="emp-profile-details-table-card">
      <form
              onSubmit={handleSubmit(handleLoanFormSubmit,(e)=>console.log(e))}
              style={{ padding: "10px" }}
            >
              <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="principalAmount">
                    Principal Amount
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true,inputProps:{min:0} }}
                      placeholder="Enter the Principal Amount"
                      type="number"
                      {...register("principalAmount")}
                      error={errors.principalAmount ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.principalAmount?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="interestRate">
                    Interest Rate <Typography variant="body2" component="span">(in Percentage)</Typography>
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true,inputProps:{min:0} }}
                      size="small"
                      type="number"
                      placeholder="Enter the Interest"
                    
                      {...register("interestRate")}
                      error={errors.interestRate ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.interestRate?.message}
                    </Typography>
                  </FormControl>
                </Grid>
           
               
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="amountOfTime">
                     Duration  <Typography variant="body2" component="span">(in Month)</Typography>
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true ,inputProps:{min:0}}}
                      size="small"
                      type="number"
                      placeholder="Enter Amount Time"
                      {...register("amountOfTime")}
                      error={errors.amountOfTime ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.amountOfTime?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="reason">
                     Reason 
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true ,inputProps:{min:0,type:"numeric"}}}
                      size="small"
                      placeholder="Enter the Reason"
                      {...register("reason")}
                      error={errors.reason ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.reason?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="document">
                    Loan Document <Typography variant="body2" component="span">(PDF,DOX only)</Typography>
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true,inputProps:{accept: ".pdf,.doc,.docx"}}}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      type="file"
                      
                      placeholder="Select employee joining Date "
                      
                      {...register("document")}
                      error={errors.document ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.document?.message}
                    </Typography>

                  </FormControl>
                </Grid>
          
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    style={{ flex: 1, margin: "0px 6px" }}
                    onClick={()=>reset()}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ flex: 1, margin: "0px 6px" }}
                    type="submit"
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>

            <Backdrop className={classes.backdrop} open={loader}>
                    <CircularProgress color="inherit" />
            </Backdrop>
    </div>
  )
}

export default GeneralLoanForm;
